export default __webpack_public_path__ + "static/media/Buick-Landing.1f355351.png";